// src/features/legacy-reports/eligibility.ts

/**
 * Pure resolution of Legacy Reports visibility (unit-tested per ADR-004);
 * useLegacyReportsEligibility is its only runtime caller. All three inputs
 * must allow: the build flag, the serviceRead permission, and the
 * server-computed cohort verdict (`legacyReportsEligible` from
 * /customer/customerinfo). `serverEligible` undefined — older gateways omit
 * the field, or customer info has not loaded yet — resolves eligible,
 * mirroring the server's fail-open rule. This is visibility only; the server
 * remains the authority and rejects ineligible cohorts on /v1/reports1.
 */
export function resolveLegacyReportsEligibility(inputs: {
  flagEnabled: boolean;
  serviceRead: boolean;
  serverEligible: boolean | undefined;
}): boolean {
  return inputs.flagEnabled && inputs.serviceRead && (inputs.serverEligible ?? true);
}
